import { render, staticRenderFns } from "./KnowledgeBaseDialogNoFileDoc.vue?vue&type=template&id=737061ed&lang=pug&"
import script from "./KnowledgeBaseDialogNoFileDoc.vue?vue&type=script&lang=js&"
export * from "./KnowledgeBaseDialogNoFileDoc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports